import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import theme from './theme';
import { CookieConsentProvider } from './contexts/CookieConsentContext';
import CookieConsentBanner from './Components/CookieConsent/CookieConsentBanner';
import ResponsiveAppBar from "./Components/Header/Header";
import Footer from "./Components/Footer/Footer";
import Home from "./Pages/Home";
import Services from "./Pages/Services";
import Projecten from "./Pages/Projecten";
import Contact from "./Pages/Contact";
import Admin from "./Pages/Admin";
import Privacy from "./Pages/Privacy";
import ClarityAnalytics from "./Components/ClarityAnalytics";
import GaAnalytics from "./Components/GaAnalytics";
import AnalyticsConsentBridge from "./Components/AnalyticsConsentBridge";
import "./App.css";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <CookieConsentProvider>
        <Router>
          <AnalyticsConsentBridge />
          <ClarityAnalytics />
          <GaAnalytics />
          <div className="App">
            <ResponsiveAppBar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/projecten" element={<Projecten />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
            <Footer />
          </div>
          <CookieConsentBanner />
        </Router>
      </CookieConsentProvider>
    </ThemeProvider>
  );
}

export default App;
